import { render, staticRenderFns } from "./IconDotsVertical.vue?vue&type=template&id=76e49df6&"
import script from "./IconDotsVertical.vue?vue&type=script&lang=js&"
export * from "./IconDotsVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports